/** Suomi. */
export default {
  header: {
    features: 'Ominaisuudet',
    pricing: 'Hinnat',
    contact: 'Yhteystiedot',
    getStarted: 'Aloita',
    login: 'Kirjaudu sisään',
  },

  footer: {
    description:
      'Alusta jäsenille, tilojen vuokraukseen, tapahtumiin ja kirjanpitoon, tehty yhdistyksille.',
    product: 'Tuote',
    help: 'Tuki',
    legal: 'Lakiasiat',
    features: 'Ominaisuudet',
    pricing: 'Hinnat',
    getStarted: 'Aloita',
    contactUs: 'Ota yhteyttä',
    privacy: 'Tietosuoja',
    terms: 'Käyttöehdot',
    copyright: 'Kaikki oikeudet pidätetään.',
  },

  home: {
    unknownTenant:
      'Osoitteesta {host} ei löytynyt aktiivista yhdistystä. Jos yhdistys on juuri luotu, sivun valmistuminen voi kestää muutaman minuutin - yritä ladata sivu uudelleen hetken kuluttua. Jos et ole varma osoitteesta tai ongelma jatkuu,',
    unknownTenantHere: 'tästä osoitteesta',
    unknownTenantContact: 'ota yhteyttä',
    heroTitlePre: 'Digitalisoi yhdistyksesi –',
    heroSubtitle:
      'Alusta jäsenille, tilojen vuokraukseen, tapahtumiin ja kirjanpitoon, tehty yhdistyksille.',
    ctaFree: 'Aloita ilmaiseksi',
    learnMore: 'Lue lisää',
    featuresTitle: 'Mitä tarvitset yhdistyksen pyörittämiseen',
    featuresSubtitle: 'Työkalut koottuna yhteen alustaan',
    features: [
      { icon: '👥', title: 'Jäsenrekisteri', desc: 'Jäsenet, jäsenyydet ja kotitaloudet, ja lasku kun jäsenyys uusitaan.' },
      { icon: '🏠', title: 'Tilojen vuokraus', desc: 'Varaukset hintoineen, sopimuksineen, vakuuksineen ja laskuineen.' },
      { icon: '📅', title: 'Tapahtumat', desc: 'Lippujen myynti kapasiteetilla ja QR-koodi ovella.' },
      { icon: '💳', title: 'Laskut ja maksut', desc: 'Laskut ja hyvityslaskut sekä maksu kortilla ja Vipps-sovelluksella Netsin kautta.' },
      { icon: '📧', title: 'Sähköposti ja tekstiviesti', desc: 'Vahvistukset, muistutukset, laskut ja liput lähetetään automaattisesti.' },
      { icon: '🌐', title: 'Oma verkkosivusto', desc: 'Yhdistyksen oma sivusto sivuineen, uutisineen ja omine ulkoasuineen.' },
    ],
    stepsTitle: 'Näin pääset alkuun',
    steps: [
      { num: 1, title: 'Lähetä pyyntö', desc: 'Kerro meille yhdistyksestä, niin perustamme sivustonne.' },
      { num: 2, title: 'Määritä', desc: 'Lisää tilat, jäsenyystyypit ja hinnat.' },
      { num: 3, title: 'Ota käyttöön', desc: 'Vastaanota varauksia, myy lippuja ja lähetä laskuja.' },
    ],
    ctaTitle: 'Valmis helpottamaan yhdistystoimintaa?',
    ctaText: 'Aloita ilmaiseksi jo tänään. Ei sitoutumisaikaa.',
    ctaButton: 'Aloita ilmaiseksi',
    heroImageAlt: 'Esimerkkiyhdistyksen hallinnan yleisnäkymä',
  },

  features: {
    heroTitle: 'Tehokkaat ominaisuudet yhdistyksellesi',
    heroSubtitle: 'Jäsenet, vuokraus, tapahtumat, laskutus ja kirjanpito yhdessä alustassa.',
    list: [
      {
        icon: '👥',
        title: 'Jäsenhallinta',
        description: 'Jäsenet, jäsenyydet ja kotitaloudet yhdessä paikassa.',
        details: [
          'Jäsenyystyypit ja lapsia sisältävät kotitaloudet',
          'Uusinta laskulla',
          'Talkootyö ja tunnit',
        ],
      },
      {
        icon: '🏠',
        title: 'Tilojen vuokraus',
        description: 'Vastaanota ja seuraa varauksia.',
        details: ['Hinnat, lisät ja pyhäpäivät', 'Verkossa allekirjoitettava sopimus', 'Vakuus ja lasku'],
      },
      {
        icon: '📅',
        title: 'Tapahtumat',
        description: 'Myy lippuja ja päästä oikeat ihmiset sisään.',
        details: [
          'Lippujen myynti kapasiteetilla',
          'Lipputyypit järjestyksessä, esimerkiksi early bird ja ovimyynti',
          'QR-koodi ovella',
        ],
      },
      {
        icon: '💳',
        title: 'Laskut ja maksut',
        description: 'Laskut ja hyvityslaskut sekä korttimaksu.',
        details: [
          'Lasku maksumuistutuksineen',
          'Kortti ja Vipps Netsin kautta',
          'Kirjanpito ja tilikartta',
        ],
      },
      {
        icon: '📧',
        title: 'Viestintä',
        description: 'Viestit lähetetään automaattisesti oikeaan aikaan.',
        details: ['Sähköposti ja tekstiviesti', 'Pohjat usealla kielellä', 'Ilmoitukset oikeaan aikaan'],
      },
      {
        icon: '🌐',
        title: 'Oma verkkosivusto',
        description: 'Yhdistyksen oma sivusto sivuineen ja uutisineen.',
        details: [
          'Sivut ja uutiset',
          'Kolme ulkoasua ja omat värit',
          'Oma verkkotunnus (me otamme sen käyttöön)',
        ],
      },
      {
        icon: '🔐',
        title: 'Turvallisuus ja tietosuoja',
        description: 'Jokainen yhdistys pidetään erillään muista.',
        details: [
          'Kaksivaiheinen kirjautuminen',
          'Tiedot tallennetaan Norjassa',
          'Henkilötietojen katselu, vienti ja poisto',
        ],
      },
    ],
    ctaTitle: 'Valmis aloittamaan?',
    ctaText:
      'Aloita ilmaiseksi jo tänään ja koe, kuinka helppoa yhdistyksen pyörittäminen voi olla.',
    ctaButton: 'Aloita ilmaiseksi',
    screensTitle: 'Tältä se näyttää',
    screensSubtitle:
      'Kuvakaappauksia esimerkkiyhdistyksestä, jonka tiedot on keksitty. Hallinta on norjaksi.',
    screens: [
      { title: 'Yleisnäkymä', text: 'Se mikä vaatii seurantaa ja mitä on tulossa, yhdellä sivulla.' },
      { title: 'Varaukset', text: 'Pyynnöt, vahvistukset ja kaikkien varausten tila.' },
      { title: 'Kalenteri', text: 'Kävijät näkevät, milloin tilat ovat vapaita ja mitä talossa tapahtuu.' },
      { title: 'Liput', text: 'Myynti lipputyypeittäin, osallistujat ja sisäänkirjaus.' },
      { title: 'Valitse paikka', text: 'Ostaja valitsee paikkansa tilan kartalta.' },
      { title: 'Salikartta', text: 'Vedä pöydät, tuolit, lava ja baari kartalle, pohjapiirros taustalla.' },
      { title: 'Jäsenyydet', text: 'Jäsenet, jäsenyystyypit ja kotitaloudet.' },
      { title: 'Laskut', text: 'Laskut ja hyvityslaskut tilan, eräpäivän ja avoimen summan kanssa.' },
      { title: 'Puhelimessa', text: 'Yhdistyksen verkkosivusto toimii puhelimessa.' },
    ],
  },

  pricing: {
    heroTitle: 'Selkeä ja läpinäkyvä hinnoittelu',
    heroSubtitle: 'Valitse yhdistyksellesi sopiva paketti.',
    loading: 'Ladataan hintoja...',
    loadError: 'Päivitettyjä hintoja ei voitu hakea. Näytetään tallennetut hinnat.',
    popular: 'Suosituin',
    perMonth: 'kr/kk',
    unlimited: 'Rajaton',
    unlimitedMembers: 'Rajattomasti jäseniä',
    upToMembers: 'Enintään {count} jäsentä',
    prioritySupport: 'Ensisijainen tuki: aloitamme 30 minuutin kuluessa, arkisin 9–15',
    planDescFree: 'Pienille yhdistyksille',
    planDescStandard: 'Aktiivisille yhdistyksille',
    planDescAdvanced: 'Suurille järjestöille',
    ctaFree: 'Aloita ilmaiseksi',
    ctaTrial: 'Lähetä pyyntö',
    faqTitle: 'Usein kysytyt kysymykset',
    faq: [
      { q: 'Voinko vaihtaa pakettia milloin tahansa?', a: 'Kyllä, ota yhteyttä, niin vaihdamme paketin.' },
      { q: 'Mitä tapahtuu, jos jäsenraja ylittyy?', a: 'Otamme yhteyttä ja sovimme päivityksestä. Mitään ei suljeta ilman että olemme puhuneet kanssanne.' },
      { q: 'Onko sitoutumisaikaa?', a: 'Ei, kaikki paketit voi irtisanoa milloin tahansa.' },
      { q: 'Tarjoatteko alennuksia yleishyödyllisille järjestöille?', a: 'Kyllä, ota yhteyttä saadaksesi erikoishinnat yleishyödyllisille järjestöille.' },
      { q: 'Mitä korttimaksu maksaa?', a: 'Kortti ja Vipps kulkevat Netsin kautta. Yhdistyksellä on oma sopimus Netsin kanssa, ja se maksaa maksun suoraan heille.' },
    ],
    emailSms: 'Sähköposti ja tekstiviesti',
    bookingsPerMonth: '{count} varausta kuukaudessa',
    unlimitedBookings: 'Rajaton määrä varauksia',
    ticketsPerMonth: '{count} lippua kuukaudessa',
    unlimitedTickets: 'Rajaton määrä lippuja',
    locations: 'Enintään {count} tilaa',
    unlimitedLocations: 'Rajaton määrä tiloja',
    storage: '{size} tallennustilaa',
    customBranding: 'Oma ulkoasu ja omat värit',
    exportCsv: 'Vienti CSV-muotoon',
    introNotice:
      'Aloitusjakson ajan kaikki paketit ovat ilmaisia. Ilmoitamme vähintään 30 päivää ennen laskutuksen alkamista.',
  },

  contact: {
    heroTitle: 'Ota yhteyttä',
    heroSubtitle: 'Olemme täällä auttamassa. Kirjoita meille, niin vastaamme niin pian kuin voimme.',
    formTitle: 'Kirjoita meille',
    formIntro:
      'Onko sinulla kysyttävää CommunityNordista, hinnoista tai siitä, miten voimme auttaa yhdistystäsi? Täytä lomake tai lähetä meille sähköpostia.',
    email: 'Sähköposti',
    name: 'Nimi',
    organization: 'Yhdistys/Järjestö',
    subject: 'Aihe',
    chooseSubject: 'Valitse aihe',
    subjectGeneral: 'Yleinen kysymys',
    subjectPricing: 'Hinnat ja tilaus',
    subjectSupport: 'Tekninen tuki',
    subjectDemo: 'Pyydä esittely',
    subjectPartnership: 'Yhteistyö',
    message: 'Viesti',
    send: 'Lähetä viesti',
    success: 'Kiitos! Olemme vastaanottaneet viestisi ja otamme yhteyttä mahdollisimman pian.',
    error: 'Jokin meni pieleen. Yritä uudelleen tai lähetä meille sähköpostia.',
    tooMany:
      'Olet lähettänyt monta viestiä. Yritä myöhemmin uudelleen tai lähetä meille sähköpostia.',
    sending: 'Lähetetään...',
    supportNote:
      'Standard- ja Edistynyt-paketeilla on ensisijainen tuki: aloitamme asian käsittelyn 30 minuutin kuluessa, arkisin 9–15.',
  },

  login: {
    title: 'Kirjaudu sisään',
    subtitle:
      'Jokaisella yhdistyksellä on oma kirjautumisensa. Kirjoita yhdistyksen osoite, niin vien sinut sinne.',
    label: 'Yhdistyksen osoite',
    placeholder: 'yhdistys',
    button: 'Siirry kirjautumiseen',
    hint:
      'Jos yhdistyksellä on oma verkkotunnus, käytä sitä. Jos et löydä osoitetta, kysy hallitukselta tai ota yhteyttä meihin.',
    invalid: 'Käytä vain pieniä kirjaimia, numeroita ja yhdysmerkkejä.',
  },

  signup: {
    heroTitle: 'Aloita CommunityNordin käyttö',
    heroSubtitle:
      'Täytä lomake luodaksesi uuden yhdistyksen. Lähetämme sähköpostia, kun tilisi on valmis.',
    formTitle: 'Luo uusi yhdistys',
    success:
      'Kiitos yhteydenotostasi! Olemme vastaanottaneet pyyntösi ja otamme yhteyttä heti, kun tilisi on valmis.',
    error: 'Lähetyksessä tapahtui virhe. Yritä uudelleen tai ota yhteyttä.',
    orgName: 'Yhdistyksen nimi',
    orgNamePlaceholder: 'Yhdistyksen nimi',
    contactPerson: 'Yhteyshenkilö',
    contactPersonPlaceholder: 'Koko nimesi',
    email: 'Sähköposti',
    phone: 'Puhelin',
    plan: 'Haluttu tilaus',
    messageOptional: 'Viesti (valinnainen)',
    messagePlaceholder: 'Kerro hieman yhdistyksestäsi...',
    sending: 'Lähetetään...',
    submit: 'Lähetä pyyntö',
    free: 'Ilmainen',
    perMonth: 'kr/kk',
    upTo50: 'Enintään 50 jäsentä',
    upTo500: 'Enintään 500 jäsentä',
    unlimitedMembers: 'Rajattomasti jäseniä',
    nextTitle: 'Mitä seuraavaksi?',
    nextSteps: [
      { title: 'Hakemus lähetetty', desc: 'Vastaanotamme hakemuksesi ja lähetämme vahvistuksen sähköpostiisi.' },
      { title: 'Käsittely', desc: 'Tiimimme käsittelee hakemuksesi yleensä 1-2 arkipäivässä.' },
      { title: 'Tervetuloa', desc: 'Saat sähköpostiisi kutsulinkin tilin luomista varten.' },
    ],
    questionsTitle: 'Kysyttävää?',
    questionsContact: 'Ota yhteyttä:',
  },

  onboarding: {
    homeTitle: 'CommunityNord-käyttöönotto',
    homeSubtitle:
      'Uuden yhdistyksen luomiseen tarvitset kutsulinkin. Pyydä sellainen ylläpitäjältä.',
    homeGotLink: 'Saitko linkin?',
    homeGotLinkText: 'Napsauta sähköpostitse saamaasi linkkiä aloittaaksesi yhdistyksesi määrityksen.',
    homeBack: '← Takaisin osoitteeseen communitynord.com',
    validating: 'Vahvistetaan kutsua...',
    invalidTitle: 'Kutsu ei kelpaa',
    invalidContact: 'Pyydä ylläpitäjältä uusi kutsulinkki.',
    connectError: 'Palvelimeen ei saatu yhteyttä. Yritä myöhemmin uudelleen.',
    deviceBound:
      'Tämä linkki on jo avattu toisella laitteella ja on sidottu siihen. Jatka avaamalla linkki ensimmäisellä laitteella tai kirjoita osoitteeseen support@communitynord.com, niin lähetämme uuden linkin.',
    genericError: 'Jokin meni pieleen. Yritä uudelleen.',
    steps: ['Tervetuloa', 'Yhdistys', 'Yhteystiedot', 'Käyttäjätili', 'Vahvista'],
    step1Title: 'Tervetuloa CommunityNordiin',
    step1Subtitle:
      'Sinut on kutsuttu luomaan uusi yhdistys. Opastamme sinut määrityksen läpi vaihe vaiheelta.',
    step1Suggested: 'Ehdotettu nimi:',
    step1SentTo: 'Kutsu lähetetty osoitteeseen:',
    step1Expires: 'Kutsu vanhenee:',
    step1Needs: 'Tarvitset seuraavat:',
    step1NeedsList: [
      'Yhdistyksen nimi',
      'Yhteystiedot',
      'Mahdollinen Y-tunnus/rekisterinumero',
      'Haluttu käyttäjätunnus ja salasana',
    ],
    step1Start: 'Aloita →',
    back: '← Takaisin',
    next: 'Seuraava →',
    step2Title: 'Tietoa yhdistyksestä',
    step2Subtitle: 'Kerro meille yhdistyksestä, joka käyttää alustaa.',
    orgName: 'Yhdistyksen nimi',
    orgNamePlaceholder: 'Esim. Helsingin Nuorisotalo',
    orgNameRequired: 'Yhdistyksen nimi vaaditaan',
    slug: 'URL-etuliite (slug)',
    slugRequired: 'URL-etuliite vaaditaan',
    slugFormat: 'Vain pieniä kirjaimia, numeroita ja yhdysviivoja',
    slugMin: 'Vähintään 2 merkkiä',
    shortName: 'Lyhytnimi',
    shortNameRequired: 'Lyhytnimi vaaditaan',
    shortNameMax: 'Enintään 10 merkkiä',
    shortNameFormat: 'Vain kirjaimia ja numeroita',
    shortNameHint: 'Käytetään etuliitteenä mm. laskunumeroissa.',
    customDomain: 'Oma verkkotunnus',
    customDomainPlaceholder: 'esim. esimerkki.fi',
    customDomainHint:
      'Valinnainen. Mahdollistaa käytön omalla verkkotunnuksella aliverkkotunnuksen lisäksi.',
    customDomainNoProtocol: 'Kirjoita vain verkkotunnus, ilman http:// tai https://',
    customDomainNoPath: 'Kirjoita vain verkkotunnus, ilman polkua',
    customDomainInvalid: 'Virheellinen verkkotunnusmuoto',
    country: 'Maa',
    countryHint: 'Maa, johon yhdistys kuuluu',
    countryNames: { NO: 'Norja', SE: 'Ruotsi', DK: 'Tanska' },
    orgNumber: 'Rekisterinumero',
    orgNumberHint: 'Valinnainen. Y-tunnus tai yhdistysrekisterinumero.',
    appearance: 'Ulkoasu',
    layout: 'Sivuston ulkoasu',
    layoutHint: 'Voidaan vaihtaa milloin tahansa kohdassa Hallinta → Brändi.',
    layouts: [
      { key: 'classic', name: 'Klassinen', description: 'Perinteinen asettelu, keskitetty sisältö ja logo vasemmalla. Sopii useimmille.' },
      { key: 'modern', name: 'Moderni', description: 'Koko leveyden etusivu ja kompakti valikko. Raikas ja ilmava tyyli.' },
      { key: 'compact', name: 'Kompakti', description: 'Tiivis asettelu ja tiheä tieto. Hyvä sisältörikkaille sivuille.' },
      { key: 'custom', name: 'Räätälöity', description: 'Oma design, joka toteutetaan yhdessä kanssamme. Otamme yhteyttä.' },
    ],
    tagline: 'Iskulause / motto',
    taglinePlaceholder: 'Esim. ”Yhdessä luomme toimintaa”',
    taglineHint: 'Valinnainen. Näytetään sivuston alatunnisteessa.',
    logo: 'Logo',
    logoUpload: 'Lataa logo',
    logoChange: 'Vaihda kuva',
    logoRemove: 'Poista',
    logoHint: 'Valinnainen. PNG/JPG/SVG, enintään 2 Mt. Voidaan lisätä myös myöhemmin.',
    logoTooBig: 'Kuva on liian suuri (enintään 2 Mt)',
    logoNotImage: 'Tiedoston on oltava kuva',
    logoUseUrl: 'Käytä sen sijaan URL-osoitetta',
    logoUrlPlaceholder: 'https://...',
    logoUrlHint: 'Logon absoluuttinen URL-osoite (https://...).',
    subscriptionPlan: 'Tilauspaketti',
    subscriptionPlanHint: 'Tämä asetetaan aloituspaketiksi ja sitä voi muuttaa portaalissa myöhemmin.',
    step3Title: 'Yhteystiedot',
    step3Subtitle: 'Kuka on yhdistyksen pääyhteyshenkilö? Tästä henkilöstä tulee tilin omistaja.',
    contactPerson: 'Yhteyshenkilö',
    contactPersonRequired: 'Yhteyshenkilö vaaditaan',
    email: 'Sähköpostiosoite',
    emailRequired: 'Sähköposti vaaditaan',
    emailInvalid: 'Virheellinen sähköpostiosoite',
    phone: 'Puhelinnumero',
    postalAddress: 'Postiosoite',
    optional: '(valinnainen)',
    streetAddress: 'Katuosoite',
    city: 'Paikkakunta',
    postalCode: 'Postinro',
    sameAsPostal: 'Käyntiosoite on sama kuin postiosoite',
    visitingAddress: 'Käyntiosoite',
    step4Title: 'Luo käyttäjätili',
    step4Subtitle:
      'Tästä käyttäjästä tulee yhdistyksen omistaja, jolla on täydet oikeudet. Voit lisätä käyttäjiä myöhemmin.',
    username: 'Käyttäjätunnus',
    usernameRequired: 'Käyttäjätunnus vaaditaan',
    usernameMin: 'Vähintään 3 merkkiä',
    usernameMax: 'Enintään 256 merkkiä',
    usernameEmailInvalid: 'Virheellinen sähköpostimuoto',
    usernameFormat:
      'Käytä tunnusmuotoa (a-z, 0-9, piste, alaviiva, yhdysviiva) tai kelvollista sähköpostiosoitetta',
    usernamePlaceholder: 'matti.meikalainen tai nimi@verkkotunnus.fi',
    usernameHint: 'Käytetään kirjautumiseen. Voi olla käyttäjätunnus tai sähköpostiosoite.',
    loginEmail: 'Sähköposti (kirjautumiseen)',
    loginEmailHint: 'Haettu edellisen vaiheen yhteystiedoista.',
    password: 'Salasana',
    passwordRequired: 'Salasana vaaditaan',
    passwordMin: 'Vähintään 8 merkkiä',
    passwordShow: 'Näytä',
    passwordHide: 'Piilota',
    passwordHint:
      'Vinkki: Käytä isojen/pienten kirjainten, numeroiden ja erikoismerkkien yhdistelmää.',
    passwordConfirm: 'Vahvista salasana',
    passwordConfirmPlaceholder: 'Toista salasana',
    passwordMismatch: 'Salasanat eivät täsmää',
    step5Title: 'Vahvista ja luo',
    step5Subtitle:
      'Tarkista tiedot ennen yhdistyksen luomista. Voit palata taaksepäin tekemään muutoksia.',
    reviewOrg: 'Yhdistys',
    reviewName: 'Nimi',
    reviewUrl: 'URL',
    reviewCustomDomain: 'Oma verkkotunnus',
    reviewCountry: 'Maa',
    reviewShortName: 'Lyhytnimi',
    reviewOrgNumber: 'Rek.nro',
    reviewPlan: 'Tilaus',
    reviewLayout: 'Ulkoasu',
    reviewTagline: 'Iskulause',
    reviewLogo: 'Logo',
    reviewContact: 'Yhteystiedot',
    reviewContactPerson: 'Yhteyshenkilö',
    reviewEmail: 'Sähköposti',
    reviewPhone: 'Puhelin',
    reviewPostal: 'Postiosoite',
    reviewVisiting: 'Käyntiosoite',
    reviewAddress: 'Osoite',
    reviewPlace: 'Paikkakunta',
    reviewAccount: 'Käyttäjätili',
    reviewUsername: 'Käyttäjätunnus',
    reviewPassword: 'Salasana',
    reviewRole: 'Rooli',
    reviewOwner: 'Omistaja (Owner)',
    creating: 'Luodaan...',
    create: 'Luo yhdistys ✓',
    successTitle: '{name} on luotu!',
    successAwaiting:
      'Valmistelemme nyt sivustoanne — tämä on manuaalinen vaihe, jossa varmistamme, että kaikki on määritetty oikein. Saatte sähköpostin osoitteeseen {email} heti, kun sivusto on käyttövalmis.',
    successAwaitingNoEmail:
      'Valmistelemme nyt sivustoanne — tämä on manuaalinen vaihe, jossa varmistamme, että kaikki on määritetty oikein. Saatte sähköpostin heti, kun sivusto on käyttövalmis.',
    successWhatNow: 'Mitä nyt tapahtuu?',
    successStep1:
      'Tarkistamme määritykset ja teemme sivuston valmiiksi. Tämä kestää yleensä vain vähän aikaa.',
    successStep2: 'Saatte sähköpostin, kun sivusto on valmis, mukana kirjautumislinkki.',
    successStep3: 'Kirjaudu sisään käyttäjätunnuksella {username} ja valitsemallanne salasanalla.',
    successDetails: 'Tietosi',
    successOrg: 'Yhdistys',
    successUrl: 'Verkko-osoite',
    successUsername: 'Käyttäjätunnus',
    successDnsTitle: 'Oma verkkotunnus: {domain}',
    successDnsIntro:
      'Jotta {domain} osoittaisi sivustoonne, verkkotunnuksen tarjoajan DNS-asetukset on päivitettävä. Valitse toinen vaihtoehdoista:',
    successDnsCnameTitle: 'Vaihtoehto 1 — CNAME (helpoin)',
    successDnsCnameText: 'Luo CNAME-tietue, joka osoittaa aliverkkotunnukseenne:',
    successDnsATitle: 'Vaihtoehto 2 — A-tietue',
    successDnsAText: 'Osoita verkkotunnus suoraan palvelimemme IP-osoitteeseen:',
    successDnsNote:
      'DNS-muutosten voimaantulo voi kestää muutaman tunnin. Huom: CNAME-tietuetta ei voi kaikilla tarjoajilla käyttää juuriverkkotunnuksessa (esimerkki.fi) — käytä silloin A-tietuetta tai CNAME:a www-aliverkkotunnuksessa. Vahvistamme verkkotunnuksen osana sivuston valmistelua.',
    successDnsType: 'Tyyppi',
    successDnsName: 'Nimi/isäntä',
    successDnsValue: 'Arvo/kohde',
  },
}
